<template>
  <v-sheet>
    Top Tours
  </v-sheet>
</template>
<script>
export default {
  name: 'TopTours',
  data: () => ({
    //
  }),
  created() {
    
  }
}
</script>